import React from "react"
import { type ConnectedProps, connect } from "react-redux"
import { Navigate } from "react-router-dom"

import { ROLE_IDS } from "../../constants/roles.ts"
import { RoutesPaths } from "../../constants/routes.ts"
import { type RootState } from "../../store"

interface PrivateRouteProps extends ConnectedProps<typeof connector> {
  children: React.ReactNode
  redirectTo?: string
}

function PrivateRoute({
  children,
  auth,
  userInfo,
  isAdmin,
  redirectTo = RoutesPaths.auth.login
}: PrivateRouteProps) {
  const isAuthorized = !!auth?.accessToken && !!userInfo && !isAdmin

  if (!isAuthorized) {
    return <Navigate to={redirectTo} replace />
  }

  // The customer portal is a separate route tree with its own chrome and
  // data scope — a customer account never reaches the staff-facing pages
  // this route guards.
  if (userInfo?.role?.id === ROLE_IDS.CUSTOMER) {
    return <Navigate to={RoutesPaths.portal.home} replace />
  }

  return <>{children}</>
}

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
  userInfo: state.auth.userInfo,
  isAdmin: state.auth.isAdmin
})

const connector = connect(mapStateToProps)
export default connector(PrivateRoute)
